
import { AsyncTask, AsyncTaskProcess, AsyncTaskStatus } from '@/types/catalogs/AsyncTask'
import CatalogsFillsService from '@/services/CatalogsFillsService'
import { BLUEError } from '@/types/Errors'
import { NUMBER } from '@/types/GeneralConstants'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    task: {
      type: Object as PropType<AsyncTask>,
      required: true
    },
    canRemoveTask: {
      type: Boolean,
      default: false
    },
    canCancelTask: {
      type: Boolean,
      default: false
    },
    remainingTime: {
      type: String
    },
    attachmentRemainingTime: {
      type: String
    }
  },
  data () {
    return {
      HUNDRED_PERCENT: NUMBER.ONE_HUNDRED as number,
      status: AsyncTaskStatus,
      hide: false,
      showExtraDetails: false,
      showCancelConfirmation: false
    }
  },
  computed: {
    getTaskId (): number {
      return this.task.id
    },
    getTaskTemplate (): string {
      return `${this.task.template.label} [v${this.task.template.version}]`
    },
    getTaskStatus (): string {
      return this.task.status
    },
    getTaskTypeTranslated (): string {
      return this.task.taskType()
    },
    getTaskProcess (): AsyncTaskProcess {
      return this.task.process
    },
    getTaskRequestId (): string {
      return this.getTaskProcess.requestId
    },
    getTaskCreationDate (): string {
      return this.task.getLocalCreationDate()
    },
    getTaskFormat (): string {
      return this.isAttachmentTask
        ? '.ZIP'
        : `.${this.getTaskProcess.format}`
    },
    getTaskError (): BLUEError {
      return this.getTaskProcess.error || new BLUEError(0, 'Sin descripción')
    },
    getProgressPercentage (): number {
      return parseInt(this.task.getPercentage().toFixed(0))
    },
    getAttachmentProgressPercentage (): number {
      return this.task.attachmentPercentage !== undefined
        ? parseInt(this.task.attachmentPercentage.toString())
        : 0
    },
    isNew (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.NEW)
    },
    isProcessing (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.PROCESSING)
    },
    isDone (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.DONE)
    },
    isError (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.ERROR)
    },
    isWaiting (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.WAITING)
    },
    isCanceled (): boolean {
      return this.taskHasStatus(AsyncTaskStatus.CANCELED)
    },
    isAttachmentTask (): boolean {
      return this.getTaskProcess.attachmentProgress !== undefined
    },
    isAttachmentTaskInProgress (): boolean {
      return this.isAttachmentTask &&
        this.getTaskProcess.attachmentProgress?.total !== undefined &&
        this.getAttachmentProgressPercentage !== undefined
    },
    stepLabel (): string {
      const stepAmount = this.isAttachmentTask ? NUMBER.TWO : NUMBER.ONE
      let currentStep = NUMBER.ONE
      if (
        this.isProcessing &&
        this.isAttachmentTaskInProgress
      ) {
        currentStep = NUMBER.TWO
      } else if (this.isProcessing) {
        currentStep = NUMBER.ONE
      }
      return `Proceso ${currentStep} de ${stepAmount}`
    },
    isGettingTaskLink (): boolean {
      let gettingLink = [this.isProcessing, this.getProgressPercentage === this.HUNDRED_PERCENT]
      if (this.isAttachmentTask) {
        gettingLink.push(this.getAttachmentProgressPercentage === this.HUNDRED_PERCENT)
      }
      return gettingLink.every(Boolean)
    },
    isIntegrationCount (): boolean {
      return this.task.type === 'INTEGRATION' && (this.isProcessing || this.isDone)
    }
  },
  methods: {
    /** @returns true if the task has a determinated status */
    taskHasStatus (status: AsyncTaskStatus): boolean {
      return this.getTaskStatus === status
    },
    /** Emit the event to remove the task notification */
    hideTask () {
      this.hide = true
      setTimeout(() => {
        this.hide = false
        this.$emit('hide-task', this.getTaskStatus, this.getTaskId, this.task.type, this.task.updateDate)
      }, 350)
    },
    showCancelTaskConfirmation () {
      this.showCancelConfirmation = true
    },
    closeCancelTaskConfirmation () {
      this.showCancelConfirmation = false
    },
    cancelTask () {
      this.$emit('cancel-task', this.task.id)
    },
    async redirectUrlResult () {
      await CatalogsFillsService.getResultByID(this.task.id)
        .then(response => {
          const url:string = response.url
          window.location.href = url
        }).catch(() => {
          this.$bvToast.toast('Lo sentimos, ocurrió un error al descargar los resultados.', {
            title: 'Error de descarga',
            variant: 'danger',
            toaster: 'b-toaster-top-right',
            autoHideDelay: 4500
          })
        })
    }
  }
})
